import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Event sent when a user updates their notification preference',
  name: 'updated_notification_preference',
  params: [
    {
      description: 'Email or InApp',
      name: 'type',
      required: true,
      type: 'enum',
      values: ['email', 'in-app'],
    },
    {
      description: 'Setting name',
      name: 'setting',
      required: true,
      type: 'enum',
      values: [
        'New comments on assets in followed boards',
        'Mentions on assets',
        "Replies in threads you've started or are in",
        'Subboard creations in followed boards',
        'Items uploaded to followed boards',
        'Custom field changes in followed boards',
        'Views of links you created',
        'Downloads from links you created',
        'Comments on links you created',
        'Submissions to content collection forms you created',
        'Custom field changes made on links you created',
        'Expiring or expired links you created',
      ],
    },
    {
      description: 'New value',
      name: 'value',
      required: true,
      type: 'boolean',
    },
  ],
};

export default META;
